import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOtpInputModule } from 'ng-otp-input';
import { ButtonComponent } from './button/button.component';
import { CheckBoxListComponent } from './checkbox-list/checkbox-list.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatepickerParserFormatter } from './datepicker/datepicker-parser-formatter';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FileReaderComponent } from './file-reader/file-reader.component';
import { GetSecureImageSourcePipe } from './get-secure-img-source/get-secure-img-source.pipe';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { NumericInputComponent } from './numeric-input/numeric-input.component';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { RadioComponent } from './radio/radio.component';
import { SelectComponent } from './select/select.component';
import { SwitchListComponent } from './switch-list/switch-list.component';
import { SwitchComponent } from './switch/switch.component';
import { TextInputComponent } from './text-input/text-input.component';
import { TimepickerComponent } from './timepicker/timepicker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    ReactiveFormsModule,
    NgOtpInputModule,
  ],
  declarations: [
    CheckboxComponent,
    SelectComponent,
    DatepickerComponent,
    RadioComponent,
    NumericInputComponent,
    SwitchComponent,
    TextInputComponent,
    FileReaderComponent,
    TimepickerComponent,
    CheckBoxListComponent,
    GetSecureImageSourcePipe,
    SwitchListComponent,
    ButtonComponent,
    IconButtonComponent,
    OtpInputComponent,
  ],
  exports: [
    CheckboxComponent,
    SelectComponent,
    DatepickerComponent,
    RadioComponent,
    NumericInputComponent,
    SwitchComponent,
    TextInputComponent,
    FileReaderComponent,
    TimepickerComponent,
    CheckBoxListComponent,
    GetSecureImageSourcePipe,
    SwitchListComponent,
    ButtonComponent,
    IconButtonComponent,
    OtpInputComponent,
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DatepickerParserFormatter },
  ],
})
export class UiKitCoreModule {}
